module.exports = "<div class=oui-stepper__steps ng-attr-name={{::$ctrl.name}} ng-attr-id={{::$ctrl.id}} ng-transclude> </div> ";